import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { ProductViewComponentDef } from '@df/catalog-ui/product/view/product-view.component.def';
import { IProductDataV3 } from '@df/catalog/product/product';
import { LocalProduct } from '../../model/product/product.decorator';
import { ProductViewLayoutComponent } from './view-layout/product-view-layout.component';
@Component({
    selector: 'product-view',
    template:
        '<product-view-layout [variant]="model.ppLayoutVariant" [product]="model" [parent]="parent!" [request]="request" [bundleSelection]="bundleSelection" (matchExactlyChange)="matchExactly($event)" ></product-view-layout>',
    standalone: true,
    imports: [forwardRef(() => ProductViewLayoutComponent)],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductViewComponent extends ProductViewComponentDef<LocalProduct<IProductDataV3>> {}
